import React, { lazy, Suspense } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';

export const AppViews = () => {

  const history = useHistory()
  let currentPath = history.location?.pathname;
  console.log(currentPath)
  console.log(currentPath.split('/'))
  const availablePaths = [
    //    '/',
    '/dashboard',
    '/calendar',
    '/dispatch',
    '/routes',
    '/routes/add',
    '/map',
    '/inbox',
    '/clients',
    '/clients/add',
    '/requests',
    '/requests/add',
    '/quotes',
    '/quotes/add',
    '/jobs',
    '/jobs/add',
    '/invoices',
    '/invoices/add',
    '/reports',
    '/account-and-billing',
    '/account-and-billing/overview',
    '/account-and-billing/company-info',
    '/account-and-billing/transactions',
    '/account-and-billing/documents',
    '/account-and-billing/delete-account',
    '/account-and-billing/overview'
  ]

  const isRouteAvailable = availablePaths.includes(currentPath);
  return (
    <Suspense fallback={<Loading cover="content" fallback={true} />}>
      <>
        <Route path={'/dashboard'} component={lazy(() => import('./dashboard'))} />
        <Route path={'/calendar'} component={lazy(() => import('./calendar'))} />
        <Route path={'/dispatch'} component={lazy(() => import('./dispatch'))} />
        <Route path={'/map'} component={lazy(() => import('./map'))} />
        <Route path={'/routes'} exact component={lazy(() => import('./routes/detail'))} />
        <Route path={'/routes/add'} exact component={lazy(() => import('./routes/add'))} />
        <Route path={'/inbox'} component={lazy(() => import('./inbox'))} />
        <Route path={'/clients/:client_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./clients/detail'))} />
        <Route path={'/clients'} exact component={lazy(() => import('./clients/list'))} />
        <Route path={'/clients/add'} exact component={lazy(() => import('./clients/add'))} />
        <Route path={'/requests/:request_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./requests/detail'))} />
        <Route path={'/requests'} exact component={lazy(() => import('./requests/list'))} />
        <Route path={'/requests/add'} exact component={lazy(() => import('./requests/add'))} />
        <Route path={'/quotes/:quote_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./quotes/detail'))} />
        <Route path={'/quotes'} exact component={lazy(() => import('./quotes/list'))} />
        <Route path={'/quotes/add'} exact component={lazy(() => import('./quotes/add'))} />
        <Route path={'/jobs/:job_id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})'} exact component={lazy(() => import('./jobs/detail'))} />
        <Route path={'/jobs'} exact component={lazy(() => import('./jobs/list'))} />
        <Route path={'/jobs/add'} exact component={lazy(() => import('./jobs/add'))} />
        <Route path={'/invoices'} exact component={lazy(() => import('./invoices/list'))} />
        <Route path={'/invoices/add'} exact component={lazy(() => import('./invoices/add'))} />
        <Route path={'/reports'} component={lazy(() => import('./reports'))} />
        <Route path={'/account-and-billing'} exact component={lazy(() => import('./account-billing/overview'))} />
        <Route path={'/account-and-billing/overview'} exact component={lazy(() => import('./account-billing/overview'))} />
        <Route path={'/account-and-billing/company-info'} exact component={lazy(() => import('./account-billing/company-info'))} />
        <Route path={'/account-and-billing/transactions'} exact component={lazy(() => import('./account-billing/transactions'))} />
        <Route path={'/account-and-billing/documents'} exact component={lazy(() => import('./account-billing/documents'))} />
        <Route path={'/account-and-billing/delete-account'} exact component={lazy(() => import('./account-billing/delete-account'))} />
        {!isRouteAvailable ? <Redirect from={''} to={'/dashboard'} /> : null}
      </>
    </Suspense>
  )
}

export default React.memo(AppViews);